import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ count, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[2000] p-4">
      <div className="bg-card rounded-xl w-full max-w-md shadow-warm-xl">
        <div className="p-4 md:p-6">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" className="md:w-8 md:h-8" />
          </div>

          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground text-center mb-2">
            تأكيد الحذف
          </h2>

          <p className="text-sm md:text-base text-muted-foreground text-center mb-6">
            هل أنت متأكد من حذف {count} {count === 1 ? 'صورة' : 'صور'}؟\nلا يمكن التراجع عن هذا الإجراء.
          </p>

          <div className="flex items-center gap-3">
            <Button
              variant="destructive"
              iconName="Trash2"
              iconPosition="right"
              onClick={onConfirm}
              fullWidth
            >
              حذف
            </Button>
            <Button
              variant="outline"
              onClick={onCancel}
              fullWidth
            >
              إلغاء
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;